// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"button--3Dn9C","button--inline":"button--inline--2wF2W","button--icon":"button--icon--BeUaj","label":"label--AoV8Q"};